import { render, staticRenderFns } from "./ImageTextMaterial.vue?vue&type=template&id=a26b9582&"
import script from "./ImageTextMaterial.vue?vue&type=script&lang=ts&"
export * from "./ImageTextMaterial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports